<template>
  <div>{{getText()}}</div>
</template>
<script>
export default {
  props: ["rows"],
  data() {
    return {
      getText() {
        let sum = 0;

        for (var row of this.rows) {
          sum += Number.parseFloat(row["size"]);
        }
        var totalmb = sum > 0 ? sum.toFixed(2) : sum;

        return "Size ( " + totalmb + " of 100 MB )";
      }
    };
  }
};
</script>